import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { CreatePromptParams } from '../api/data-connectors/create-prompt'
import { createPrompt } from '../api/data-connectors/create-prompt'
import type { Prompt } from '../types'
import { htmlToPlainText } from '../utils/html-sanitization/htmlToPlainText'
import { useNotification } from './useNotification'

export function useCreatePrompt() {
  const { notify } = useNotification()
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userPrompt, llmModel, systemPrompt, reviewMode }: CreatePromptParams) =>
      createPrompt({ userPrompt: htmlToPlainText(userPrompt), llmModel, systemPrompt, reviewMode }),
    onSuccess: async (prompt: Prompt) => {
      await queryClient.invalidateQueries({ queryKey: ['prompts'] })
      notify({
        isSuccess: true,
        text: t('prompts.saveSuccessToast', { title: prompt.title }),
        position: 'top',
        // uncomment when edit prompt is implemented in # 3798 or # 4064
        // link: {
        //   label: t('prompts.showPrompt'),
        //   href: `/prompts?id=${prompt.promptId}`,
        // },
      })
    },
    onError: () => {
      notify({ isSuccess: false, text: t('prompts.saveFailureToast'), position: 'top' })
    },
  })
}
